import dayjs from 'utils/dayjs';

/**
 * Formats a date and time range into a human-readable string.
 *
 * @example output: "Thu, Jun 5, 2025 07:30 PM - 10:30 PM".
 *
 */
export const formatDateRange = (
    startTime: string | number | Date | dayjs.Dayjs,
    endTime: string | number | Date | dayjs.Dayjs
): string => {
    const start = dayjs(startTime);
    const end = dayjs(endTime);
    // Format like: "Thu, Jun 5, 2025 07:30 PM - 10:30 PM"
    const formattedDate = start.format('ddd, MMM D, YYYY');
    const formattedStartTime = start.format('hh:mm A');
    const formattedEndTime = end.format('hh:mm A');

    return `${formattedDate} ${formattedStartTime} - ${formattedEndTime}`;
};

/**
 * Ensures a string representation of a number has two digits.
 * e.g. "3" => "03", "12" => "12"
 * @private
 * @param t - The time value to format as a string or number
 * @returns The formatted string with two digits
 */
const forceTwoDigits = (t: string | number): string => `0${t}`.slice(-2);

/**
 * Formats a duration in hours and minutes into a human-readable string.
 * @function
 * @param hours - The number of hours
 * @param minutes - The number of minutes (optional, defaults to 0)
 * @returns The formatted duration (e.g., "02:30")
 */
const formatDuration = (
    hours: string | number,
    minutes?: string | number
): string => {
    return `${forceTwoDigits(hours)}:${forceTwoDigits(minutes || 0)}`;
};

export default formatDuration;
